import React from "react"
import { FlexView } from "./components/common"
import Header from "./containers/layout/Header"
import Home from "./pages/Home"
import Stock from "./pages/Stock"
import Safety from "./pages/Safety"
import SafetyPlanningNm from "./pages/SafetyPlanningNm"
import SafetyRegisterNm from "./pages/SafetyRegisterNm"
import InspectionReportPage from "./pages/InspectionReportPage"
import FieldDataPage from "./pages/FieldDataPage"
// import FieldManualDataPage from "./pages/FieldManualDataPage"
// import FieldTagsPage from "./pages/FieldTagsPage"
// import AccessDenied from './pages/AccessDenied'
import InspectionReportApprovalPage from "./pages/InspectionReportApprovalPage"
import VallourecServicesDataPage from "pages/VallourecServicesDataPage"
import VallourecServicesManualDataPage from "pages/VallourecServicesManualDataPage"
import Login from "./pages/Login"
import Transport from "pages/ManagementTransport"
import TransportInformation from "pages/ManagementTransportInformation"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"
import PrivateRoute from "./containers/router/PrivateRoute"
import { StockProvider } from "stores/StockStore"
import { SafetyStockProvider } from "stores/SafetyStockStore"
import { InspectionReportProvider } from "stores/InspectionReportStore"
import { FieldDataProvider } from "stores/FieldDataStore"
import { VallourecServicesDataProvider } from "stores/VallourecServicesDataStore"
import VallourecServicesTagsPage from "pages/VallourecServicesTagsPage"
import { TransportProvider } from "stores/ManagementTransportStore"

const Router = () => {

  return (
    <FlexView height="100vh" minWidth="900px">
      <BrowserRouter>
        <Header />
        <Switch>
          <Route path="/login" exact>
            <Login />
          </Route>
          <PrivateRoute path="/">
            <StockProvider>
              <Switch>
                <PrivateRoute path="/" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/stock" exact>
                  <Stock />
                </PrivateRoute>
                <PrivateRoute path="/safety/register">
                  <SafetyStockProvider>
                    <SafetyRegisterNm />
                  </SafetyStockProvider>
                </PrivateRoute>
                <PrivateRoute path="/safety/planning">
                  <SafetyStockProvider>
                    <SafetyPlanningNm />
                  </SafetyStockProvider>
                </PrivateRoute>
                <PrivateRoute path="/safety">
                  <SafetyStockProvider>
                    <Safety />
                  </SafetyStockProvider>
                </PrivateRoute>
                <PrivateRoute path="/inspection-report" exact>
                  <InspectionReportProvider>
                    <InspectionReportPage />
                  </InspectionReportProvider>
                </PrivateRoute>
                <PrivateRoute path="/inspection-report/approval" exact>
                  <InspectionReportProvider>
                    <InspectionReportApprovalPage />
                  </InspectionReportProvider>
                </PrivateRoute>
                <PrivateRoute path="/field-data" exact>
                  <FieldDataProvider>
                    <FieldDataPage />
                  </FieldDataProvider>
                </PrivateRoute>
                {/* <PrivateRoute path="/field-data/tags" exact>
                  <FieldDataProvider>
                    <FieldTagsPage />
                  </FieldDataProvider>
                </PrivateRoute> */}
                {/* <PrivateRoute path="/field-manual-data" exact>
                  <FieldDataProvider>
                    <FieldManualDataPage />
                  </FieldDataProvider>
                </PrivateRoute> */}
                <PrivateRoute path="/vallourec-services-data" exact>
                  <VallourecServicesDataProvider>
                    <VallourecServicesDataPage />
                  </VallourecServicesDataProvider>
                </PrivateRoute>
                <PrivateRoute path="/vallourec-services-data/tags" exact>
                  <VallourecServicesDataProvider>
                    <VallourecServicesTagsPage />
                  </VallourecServicesDataProvider>
                </PrivateRoute>
                <PrivateRoute path="/vallourec-services-manual-data" exact>
                  <VallourecServicesDataProvider>
                    <VallourecServicesManualDataPage />
                  </VallourecServicesDataProvider>
                </PrivateRoute>
                <PrivateRoute path="/management-transport" exact>
                  <TransportProvider>
                    <Transport />
                  </TransportProvider>
                </PrivateRoute>
                <PrivateRoute path="/management-transport/information" exact>
                  <TransportProvider>
                    <TransportInformation />
                  </TransportProvider>
                </PrivateRoute>
                <PrivateRoute path="/">
                  <Redirect to="/" />
                </PrivateRoute>
              </Switch>
            </StockProvider>
          </PrivateRoute>
        </Switch>
      </BrowserRouter>
    </FlexView>
  )
}

export default Router
